import { connect } from 'react-redux'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import { createSelector } from 'reselect'
import TripDetails from 'src/components/riders/rider-portal/trips/details/TripDetails'
import { actionCreators, cancelTrip, getTripDetails } from 'src/state/actions/rider-portal/main'
import { IStoreState } from 'src/types'

interface MatchParams {
  id?: string
}

interface OwnPropsWithMatch {
  match?: {
    params?: MatchParams
  }
  [key: string]: any
}

// Memoized selectors
const selectRiderPortal = (state: IStoreState) => state.riderPortal

const selectCurrentlyViewedTrips = createSelector(
  selectRiderPortal,
  riderPortal => riderPortal.trips.currentlyViewedTrips
)

const selectLoading = createSelector(
  selectRiderPortal,
  riderPortal => riderPortal.loading
)

export function mapStateToProps(state: IStoreState, ownProps: OwnPropsWithMatch): Record<string, unknown> {
  const trip = selectCurrentlyViewedTrips(state)
  const tripId = ownProps.match && ownProps.match.params && ownProps.match.params.id ? ownProps.match.params.id : ''
  const { fetchingTripDetails, updatingTrip } = selectLoading(state)

  return {
    fetchingTripDetails,
    trip,
    tripId,
    updatingTrip
  }
}

export function mapDispatchToProps(dispatch: ThunkDispatch<IStoreState, unknown, AnyAction>): Record<string, unknown> {
  return {
    cancelTrip: (tripId: string) => {
      return dispatch(cancelTrip(tripId, 'Trip cancelled by rider'))
    },
    getTripDetails: (tripId: string, initialFetch: boolean) => dispatch(getTripDetails(tripId, initialFetch)),
    resetCurrentlyViewedTripsData: () => dispatch(actionCreators.resetCurrentlyViewedTripsData())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripDetails)



// WEBPACK FOOTER //
// ./src/containers/riders/rider-portal/trips/details/TripDetails.ts